const ERRORS = {
  PROGRAM_NOT_AVAILABLE: {
    message: 'Le programme n\'est pas disponible',
    status: 400,
    extra: 'PROGRAM_NOT_AVAILABLE'
  },
  PROGRAM_NOT_OPTIONABLE: {
    message: 'Le programme n\'est pas optionnable',
    status: 400,
    extra: 'PROGRAM_NOT_OPTIONABLE'
  },
  LOT_NOT_AVAILABLE: {
    message: 'Le lot n\'est pas disponible',
    status: 400,
    extra: 'LOT_NOT_AVAILABLE'
  },
  WRONG_CONTACT: {
    message: 'Ce contact n\'appartient pas au vendeur spécifié',
    status: 400,
    extra: 'WRONG_CONTACT'
  },
  SELLER_OPTION_ALREADY_EXISTS: {
    message: 'Une option sur ce lot a déjà été prise par ce vendeur',
    status: 400,
    extra: 'SELLER_OPTION_ALREADY_EXISTS'
  },
  MAX_OPTIONS_LIMIT: {
    message: 'Nombre maximum d\'option atteint pour ce vendeur.',
    status: 400,
    extra: 'MAX_OPTIONS_LIMIT'
  },
  MAX_OPTIONS_BY_CLIENT_LIMIT: {
    message: 'Nombre maximum d\'option atteint pour ce vendeur avec ce client.',
    status: 400,
    extra: 'MAX_OPTIONS_BY_CLIENT_LIMIT'
  },
  MAX_OPTIONS_BY_LOT_LIMIT: {
    message: 'Nombre maximum d\'option atteint sur ce lot.',
    status: 400,
    extra: 'MAX_OPTIONS_BY_LOT_LIMIT'
  },
  SMS_API_CALL_LIMIT: {
    message: 'Nombre maximum de sms envoyé. Veuillez attendre 1h pour re-utiliser cette fonctionnalité.',
    status: 400,
    extra: 'SMS_API_CALL_LIMIT'
  },
  EXTERNAL_ACCESS_LOGIN_NOT_AVAILABLE: {
    message: 'Ce login est deja utilisé pour un autre accès.',
    status: 400,
    extra: 'EXTERNAL_ACCESS_LOGIN_NOT_AVAILABLE'
  },
  CONTACT_HAS_SALES: {
    message: 'Ce contact est lié à une ou plusieurs ventes.',
    status: 403,
    extra: 'CONTACT_HAS_SALES'
  },
  CONTACT_HAS_OPTIONS: {
    message: 'Ce contact est lié à une ou plusieurs options.',
    status: 403,
    extra: 'CONTACT_HAS_OPTIONS'
  },
  USER_HAS_SALES: {
    message: 'Cet utilisateur est lié à une ou plusieurs ventes.',
    status: 403,
    extra: 'USER_HAS_SALES'
  },
  LOT_HAS_SALES: {
    message: 'un ou plusieurs lots sont liés à une vente.',
    status: 403,
    extra: 'LOT_HAS_SALES'
  },
  PROFIL_LIMIT_REACHED: {
    message: 'Cette société ne peut pas avoir d\' utilisateur de ce profil supplémentaire.',
    status: 400,
    extra: 'PROFIL_LIMIT_REACHED'
  },
  MANAGER_LIMIT_REACHED: {
    message: 'Cette société ne peut pas avoir de manager supplémentaire.',
    status: 400,
    extra: 'MANAGER_LIMIT_REACHED'
  },
  RUNNING_OPTIONS_ON_LOT: {
    message: 'Des lots ont des options en cours.',
    status: 400,
    extra: 'RUNNING_OPTIONS_ON_LOT'
  },
  LOT_REF_ALREADY_USED: {
    message: 'Cette référence est déjà utilisée pour un lot de ce programme',
    status: 400,
    extra: 'LOT_REF_ALREADY_USED'
  },
  PENDING_DENUNCIATION_ALREADY_EXIST: {
    message: 'Vous ne pouvez dénoncer le même contact plusieurs fois sur un même lot',
    status: 400,
    extra: 'PENDING_DENUNCIATION_ALREADY_EXIST'
  },
  ADV_REMUNERATION_ERROR: {
    inline: true,
    message: 'Total rémunérations vendeurs supérieur au taux de commercialisation',
    status: 400,
    extra: 'ADV_REMUNERATION_ERROR'
  },
  ADV_BONUS_COMPUTING_ERROR: {
    inline: true,
    message: 'Bonus supérieur au restant sur vente',
    status: 400,
    extra: 'ADV_BONUS_COMPUTING_ERROR'
  },
  ADV_SHARE_DEPOSIT_ERROR: {
    inline: true,
    message: 'Valeur d\'acompte supérieur à la part totale du vendeur',
    status: 400,
    extra: 'ADV_SHARE_DEPOSIT_ERROR'
  },
  ADV_SHARE_REMUNERATION_ERROR: {
    inline: true,
    message: 'Rémunération du vendeur supérieure au taux de commercialisation',
    status: 400,
    extra: 'ADV_SHARE_REMUNERATION_ERROR'
  },
  ADV_SHARE_TERMINATED_ERROR: {
    inline: true,
    message: 'Facture définitive du solde finalisée, modification sur rémunération impossible',
    status: 400,
    extra: 'ADV_SHARE_TERMINATED_ERROR'
  },
  ACCOUNT_DISABLED: {
    inline: true,
    message: 'Vous n\'êtes pas autorisé à effectuer cette action.',
    status: 403,
    extra: 'ACCOUNT_DISABLED'
  },
  ACCOUNT_DELETED: {
    inline: true,
    message: 'Vous n\'êtes pas autorisé à effectuer cette action.',
    status: 403,
    extra: 'ACCOUNT_DELETED'
  },
  NO_LOTS_IN_PROGRAM: {
    inline: false,
    message: 'Aucun lot disponible dans le programme, impossible de générer l\'export de la fiche programme. ',
    status: 400,
    extra: 'NO_LOTS_IN_PROGRAM'
  }

  // ,
  /* },
  LOT_REF_ALREADY_USED: {
    message: 'Cette référence est déjà utilisée pour un lot de ce programme',
    status: 400,
    extra: 'LOT_REF_ALREADY_USED'
  }/*,
  LOT_REF_ALREADY_USED: {
    message: 'Cette référence est déjà utilisée pour un lot de ce programme',
    status: 400,
    extra: 'LOT_REF_ALREADY_USED'
  }/*,
   MAX_OPTIONS_BY_LOT_LIMIT: {
   message: 'the option can\'t be cancel at the moment',
   status: 400,
   extra: 'MAX_OPTIONS_BY_LOT_LIMIT'
   },
   MAX_OPTIONS_BY_LOT_LIMIT: {
   message: 'the option can\'t be cancel at the moment',
   status: 400,
   extra: 'MAX_OPTIONS_BY_LOT_LIMIT'
   } */
}

export default {
  data () {
    return {
      errorList: ERRORS,
      inlineError: null,
      displayInlineError: false
    }
  },
  computed: {
    advErrors () {
      return {
        ADV_REMUNERATION_ERROR: ERRORS.ADV_REMUNERATION_ERROR,
        ADV_BONUS_COMPUTING_ERROR: ERRORS.ADV_BONUS_COMPUTING_ERROR,
        ADV_SHARE_DEPOSIT_ERROR: ERRORS.ADV_SHARE_DEPOSIT_ERROR,
        ADV_SHARE_REMUNERATION_ERROR: ERRORS.ADV_SHARE_REMUNERATION_ERROR,
        ADV_SHARE_TERMINATED_ERROR: ERRORS.ADV_SHARE_TERMINATED_ERROR
      }
    },
    advErrorsList () {
      return Object.keys(this.advErrors)
    }

  },
  methods: {
    handleError (r, defaultMessage = 'Erreur') {
      const data = (r.response) ? r.response.data : r.data
      const err = {type: 'is-danger'}
      if (data.extra && data.extra in this.errorList && this.errorList[data.extra].message) {
        err.text = this.errorList[data.extra].message
      } else if (data.description in this.errorList && this.errorList[data.description].message) {
        err.text = this.errorList[data.description].message
      } else {
        err.text = defaultMessage
      }
      if (data.extra && data.extra in this.errorList && this.errorList[data.extra].inline && this.displayInlineError) {
        this.inlineError = err
        setTimeout(() => {
          this.inlineError = null
        }, 5000)
      } else {
        this.$notify(err)
      }
    },
    clearInlineError () {
      this.inlineError = null
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/ErrorMixin.js